import tw from "twin.macro"

export const Variants = tw.div`
  flex flex-row justify-start my-0-8
`
